module.exports = __webpack_public_path__ + "static/media/play-store-logo.212c57da.png";